module.exports = __webpack_public_path__ + "media/application/images/technology/secondary_nav/founders-presentation-5560d68bc0e0672ee9da4b1bf83e54f7.jpg";